import React, { useState } from 'react';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from "@date-io/moment";

import { IconButton } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';

function AxlDatePicker(props) {
  const { label, value, handleChange, format, variant, inputVariant, size, ...otherProps } = props;
  const [open, setOpen] = useState(false);

  const handleDeleteDate = (e) => {
    handleChange(null);
    e.stopPropagation();
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardDatePicker
        label={label}
        onChange={handleChange}
        {...otherProps}
        format={format || 'YYYY/MM/DD'}
        value={value}
        variant={variant || 'inline'}
        inputVariant={inputVariant || 'outlined'}
        size={size || 'small'}
        autoOk
        InputProps={{
          startAdornment: value && (
            <IconButton onClick={handleDeleteDate} style={{ order: 1, padding: 0 }}>
              <ClearIcon fontSize="small" />
            </IconButton>
          ),
        }}
        InputAdornmentProps={{
          position: 'end',
          style: { order: 2, marginLeft: 0 },
        }}
        open={open}
        onClick={() => setOpen(true)}
        onClose={() => setOpen(false)}
      />
    </MuiPickersUtilsProvider>
  );
}

export default AxlDatePicker;
